import * as React from "react"
import Button from "@mui/material/Button"
import Dialog from "@mui/material/Dialog"
import DialogActions from "@mui/material/DialogActions"
import DialogContent from "@mui/material/DialogContent"
import DialogTitle from "@mui/material/DialogTitle"
import TextField from "@mui/material/TextField"
import { AXIOS_API_INSTANCE } from "../../../Constants"
import { send_authorized_request } from "../../../Constants/cognito"
import { useSnackbar } from 'notistack';
import { IconButton, InputAdornment } from "@mui/material"
import Grid from "@mui/material/Grid2"
import CloseIcon from '@mui/icons-material/Close';
import DeleteIcon from '@mui/icons-material/Delete';
import AttachMoneyIcon from '@mui/icons-material/AttachMoney'
import AddCircleSharpIcon from '@mui/icons-material/AddCircleSharp';

export default function CreateInventoryItemModal({
    open,
    closeModal
}) {
    const { enqueueSnackbar } = useSnackbar();
    const [inventoryItem, setInventoryItem] = React.useState({
        name: '',
        description: '',
        vendor_cost: 0,
        default_price: 0,
        quantity: 1
    })
    const [identifiers, setIdentifiers] = React.useState([])
    const [newIdentifier, setNewIdentifier] = React.useState('')

    const handleChange = (prop) => (event, sometimes_new_value) => {
        setInventoryItem({
            ...inventoryItem,
            [prop]: event.target.value,
        })
    }
    const remove_identifier = (index) => {
        identifiers.splice(index, 1)
        setIdentifiers(identifiers)
    }

    const save = (event) => {
        send_authorized_request(() =>
            AXIOS_API_INSTANCE.put(
                `inventoryitems`,
                { ...inventoryItem, lookups: identifiers }
            ).then(() => {
                enqueueSnackbar('Successfully created inventory item', { variant: 'success' })
                closeModal(true)
            })
        )
    }

    return (
        (<div>
            <Dialog
                open={open}
                onClose={closeModal}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
            >
                <DialogTitle>
                    {"Creating Inventory Item"}
                    <IconButton
                        aria-label="close"
                        onClick={closeModal}
                        sx={{
                            position: 'absolute',
                            right: 8,
                            top: 8
                        }}
                    >
                        <CloseIcon />
                    </IconButton>
                </DialogTitle>
                <DialogContent>
                    <TextField
                        autoFocus
                        margin="dense"
                        id="name"
                        label="Name"
                        type="text"
                        fullWidth
                        variant="filled"
                        value={inventoryItem.name || ""}
                        onChange={handleChange("name")}
                    />
                    <TextField
                        autoFocus
                        margin="dense"
                        id="description"
                        label="Description"
                        type="text"
                        fullWidth
                        variant="filled"
                        value={inventoryItem.description || ""}
                        onChange={handleChange("description")}
                    />
                    <TextField
                        autoFocus
                        margin="dense"
                        id="vendor_cost"
                        label="Vendor Cost"
                        type="number"
                        fullWidth
                        variant="standard"
                        value={inventoryItem.vendor_cost || 0}
                        onChange={handleChange("vendor_cost")}
                        slotProps={{
                            input: {
                                startAdornment: (
                                    <InputAdornment position="start">
                                        {<AttachMoneyIcon />}
                                    </InputAdornment>
                                ),
                            }
                        }}
                    />
                    <TextField
                        autoFocus
                        margin="dense"
                        id="default_price"
                        label="Default Price"
                        type="number"
                        fullWidth
                        variant="standard"
                        value={inventoryItem.default_price || 0}
                        onChange={handleChange("default_price")}
                        slotProps={{
                            input: {
                                startAdornment: (
                                    <InputAdornment position="start">
                                        {<AttachMoneyIcon />}
                                    </InputAdornment>
                                ),
                            }
                        }}
                    />
                    <TextField
                        autoFocus
                        margin="dense"
                        id="quantity"
                        label="Quantity When Purchasing This Item"
                        type="number"
                        fullWidth
                        variant="standard"
                        value={inventoryItem.quantity || 1}
                        onChange={handleChange("quantity")}
                    // InputProps={{
                    //     startAdornment: (
                    //         <InputAdornment position="start">
                    //             {<AttachMoneyIcon />}
                    //         </InputAdornment>
                    //     ),
                    // }}
                    />
                    <Grid container direction={'column'} alignItems={'center'}>
                        {identifiers.map((item, index) =>
                            <Grid container alignItems={'center'} key={item + index} size="grow">
                                <Grid size="grow">
                                    <span>{item}</span>
                                </Grid>
                                <Grid size="auto">
                                    <IconButton aria-label="delete" onClick={() => remove_identifier(index)}>
                                        <DeleteIcon color="error" />
                                    </IconButton>
                                </Grid>
                            </Grid>
                        )}
                    </Grid>
                    <Grid container alignItems={'center'}>
                        <Grid size="grow">
                            <TextField
                                autoFocus
                                margin="dense"
                                id="newidentifier"
                                label="Add UPC/SKU"
                                type="text"
                                fullWidth
                                variant="filled"
                                value={newIdentifier || ""}
                                onChange={(e) => setNewIdentifier(e.target.value)}
                            />
                        </Grid>
                        <Grid size="auto">
                            <IconButton aria-label="delete" onClick={() => { setIdentifiers(identifiers.concat([newIdentifier])); setNewIdentifier('') }}>
                                <AddCircleSharpIcon />
                            </IconButton>
                        </Grid>
                    </Grid>
                </DialogContent>
                <DialogActions>
                    <Grid container justifyContent="space-between" sx={{ padding: "0px 30px 10px 30px", width: '100%' }}>
                        <Grid size="auto">
                        </Grid>
                        <Grid size="auto">
                            <Button variant="contained" autoFocus onClick={save}>
                                {"Create"}
                            </Button>
                        </Grid>
                    </Grid>
                </DialogActions>
            </Dialog>
        </div>)
    );
}
